module.exports = __webpack_public_path__ + "img/37772-059.4dc2941a.jpg";